import React from 'react';
import PropTypes from 'prop-types';

const CardAccessIcon = ({ className = null }) => (
  <svg
    fill="#000000"
    className={className}
    width="24px"
    height="24px"
    viewBox="0 0 256 256"
    id="Flat"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M224,52H32A12.01343,12.01343,0,0,0,20,64V96.79443c-.00024.02-.00586.03809-.00586.05811s.00562.03809.00586.0581V192a12.01343,12.01343,0,0,0,12,12H224a12.01343,12.01343,0,0,0,12-12V64A12.01343,12.01343,0,0,0,224,52ZM32,60H224a4.00427,4.00427,0,0,1,4,4V92.85254H28V64A4.00427,4.00427,0,0,1,32,60ZM224,196H32a4.00427,4.00427,0,0,1-4-4V100.85254H228V192A4.00427,4.00427,0,0,1,224,196Zm-20.00586-28a4.0002,4.0002,0,0,1-4,4h-32a4,4,0,0,1,0-8h32A4.0002,4.0002,0,0,1,203.99414,168Zm-64,0a4.0002,4.0002,0,0,1-4,4h-16a4,4,0,0,1,0-8h16A4.0002,4.0002,0,0,1,139.99414,168Z" />
  </svg>
);

CardAccessIcon.propTypes = {
  className: PropTypes.string,
};


export default CardAccessIcon;
